import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import { insuranceLogos } from "@/mocks/ppcare";

export default function InsuranceSection() {
  return (
    <section id="insurance" className="bg-background-50 py-16 md:py-24">
      <div className="container">
        <Reveal>
          <SectionHeading
            eyebrow="We Accept Cash and"
            title={
              <>
                Insurance Plans <span className="text-accent-500">Including</span>
              </>
            }
          />
        </Reveal>

        <div className="mx-auto mt-14 grid max-w-5xl grid-cols-2 gap-5 sm:grid-cols-3 lg:grid-cols-5">
          {insuranceLogos.map((logo, index) => (
            <Reveal key={logo.name} delay={(index % 5) * 60}>
              <div className="flex h-24 items-center justify-center rounded-lg border border-background-200 bg-background-100 p-4 transition-colors hover:border-primary-200">
                <img
                  src={logo.image}
                  alt={logo.name}
                  className="max-h-12 w-auto max-w-full object-contain"
                />
              </div>
            </Reveal>
          ))}
        </div>

        <div className="mt-10 flex justify-center">
          <a
            href="#insurance"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-primary-500 px-7 py-3.5 text-sm font-semibold text-primary-600 transition-colors hover:bg-primary-500 hover:text-background-50"
          >
            View All Insurance Plans
            <i className="ri-arrow-right-line" />
          </a>
        </div>
      </div>
    </section>
  );
}